import { generatePath } from "react-router";

import { copyToClipboard } from "shared/utils";

import { RouteKey, routes } from "services/routes";

export const buildShareURL = (shareId: string): string =>
  `${window.location.origin}${generatePath(routes[RouteKey.DuckSharedThread], {
    shareId,
  })}`;

/**
 * Reading navigator.clipboard throws outright where the Clipboard API is
 * unavailable, so a failed copy does not always surface as a rejected write.
 */
export const copyShareURL = async (url: string): Promise<boolean> => {
  try {
    return await copyToClipboard(url);
  } catch {
    return false;
  }
};
